import {
  GEOLOCATION_PASSED,
  GEOLOCATION_REJECTED,
  LOCATION_FAILURE,
  LOCATION_IN_PROGRESS,
} from '@fanduel/geolocation-sdk';

export type SdkLogEvent = {
  eventName: string;
  logLevel: string;
  attributes: Record<string, unknown>;
};

export enum GeolocationProgress {
  NotStarted = 'not-started',
  InProgress = 'in-progress',
  Success = 'success',
  Failed = 'failed',
  Invalidated = 'invalidated',
}

export type GeolocationDomain = 'casino' | 'poker';

export type GeolocationParams = {
  region: string;
  sessionId: string;
  userId: string;
  userAuthToken: string;
  geocomplyToken?: string;
};

export type Environment =
  | 'prod'
  | 'cert'
  | 'qa'
  | 'http://localhost:3000'
  | 'dev';

/*
 * Legacy aw-geolocation action type constants.
 * These are used for backward compatibility with older iOS/Android native apps
 * that still send events with aw-geolocation/* naming.
 */
export const AW_LOCATION_IN_PROGRESS =
  'aw-geolocation/location-in-progress' as const;
export const AW_GEOLOCATION_PASSED =
  'aw-geolocation/geolocation-passed' as const;
export const AW_GEOLOCATION_REJECTED =
  'aw-geolocation/geolocation-rejected' as const;
export const AW_LOCATION_FAILURE = 'aw-geolocation/location-failure' as const;

export type AwGeolocationActionType =
  | typeof AW_LOCATION_IN_PROGRESS
  | typeof AW_GEOLOCATION_PASSED
  | typeof AW_GEOLOCATION_REJECTED
  | typeof AW_LOCATION_FAILURE;

/**
 * Mapping from legacy aw-geolocation action types to geolocation-sdk action types.
 */
export const AW_TO_SDK_MAP: Record<
  AwGeolocationActionType,
  | typeof LOCATION_IN_PROGRESS
  | typeof GEOLOCATION_PASSED
  | typeof GEOLOCATION_REJECTED
  | typeof LOCATION_FAILURE
> = {
  [AW_LOCATION_IN_PROGRESS]: LOCATION_IN_PROGRESS,
  [AW_GEOLOCATION_PASSED]: GEOLOCATION_PASSED,
  [AW_GEOLOCATION_REJECTED]: GEOLOCATION_REJECTED,
  [AW_LOCATION_FAILURE]: LOCATION_FAILURE,
} as const;
